import { ReactNode } from 'react'
import { toast } from 'react-hot-toast'
import cn from 'classnames'

import { LabelValueWrapper } from './LabelValue.styled'

import { copyTextToClipboard, tr } from 'mmfintech-commons'
import { CoreButton } from '../CoreButton'

type LabelValueProps = {
  label?: ReactNode
  value?: string
  dataTest?: string
  enableCopy?: boolean
  copyValue?: string
  valueClass?: string
}

export const LabelValue = ({ label, value, dataTest, enableCopy, copyValue, valueClass }: LabelValueProps) => {
  const handleCopyClick = () => {
    copyTextToClipboard(copyValue || value)
    const message = tr('CHECKOUT.LABEL_VALUE.COPY_SUCCESS', 'Value copied to clipboard.')
    toast.remove()
    toast.success(message.toString())
  }

  if (value?.length) {
    return (
      <LabelValueWrapper className='row'>
        <div className='label'>{label}</div>
        {enableCopy ? (
          <div className='copy-box'>
            <span data-test={dataTest}>{value}</span>
            <CoreButton
              type='button'
              variation='primary'
              text={tr('CHECKOUT.LABEL_VALUE.COPY_BUTTON', 'Copy')}
              onClick={handleCopyClick}
            />
          </div>
        ) : (
          <div className={cn('value', valueClass)} data-test={dataTest}>
            {value}
          </div>
        )}
      </LabelValueWrapper>
    )
  }

  return null
}
